import endpoint from 'src/store/modules/endpoint'

export const partnerListTable = {
  showTable: true,
  tableApi: endpoint.state.partner,
  exportApi: endpoint.state.partner,
  filterResponse: {},
  columns: [
    {
      name: 'name',
      field: (row) => {
        return row.name
          ? `<div
              router-push="${encodeURIComponent(
                JSON.stringify({
                  name: 'partner-form',
                  params: {
                    action: 'preview',
                    id: row.id,
                    name: row.name
                  }
                })
              )}"
            >${row?.name}</div>`
          : '-'
      },
      label: 'Nama',
      sortable: true,
      align: 'center',
      rowClass: 'text-center'
    },
    {
      name: 'referal',
      field: (row) => {
        return row.referal || '-'
      },
      label: 'Kode Referal',
      sortable: true,
      align: 'center',
      rowClass: 'text-center'
    }
  ]
}
